/**
 * Configuración base del cliente API de commerce.
 *
 * Migración First Class: la capa de datos consume dos APIs FastAPI propias
 * en vez de Supabase:
 *   - api-core      → auth de clientes, lealtad, catálogo (proxy).
 *   - api-taquilla  → eventos, carrito, órdenes, pagos, QR, inventario.
 *
 * Ambas comparten el mismo JWT (Core es el IdP; Taquilla valida el access
 * token de Core con el mismo secreto), así que un único token sirve para
 * las dos. Las URLs vienen de env (ver `.env.example`).
 */

function readEnv(key: keyof ImportMetaEnv, fallback: string): string {
  const value = import.meta.env[key];
  if (typeof value === 'string' && value.trim().length > 0) {
    return value.trim().replace(/\/+$/, '');
  }
  return fallback;
}

/** Base URL de api-core (sin barra final). */
export const API_CORE_URL = readEnv('VITE_API_CORE_URL', 'http://localhost:6000');

/** Base URL de api-taquilla (sin barra final). */
export const API_TAQUILLA_URL = readEnv('VITE_API_TAQUILLA_URL', 'http://localhost:6001');

/** Base URL del WebSocket de realtime (sin barra final). */
export const WS_URL = readEnv('VITE_WS_URL', 'ws://localhost:6000/ws');

/** Prefijo de versión de ambas APIs. */
export const API_VERSION_PREFIX = '/v1';

/**
 * Normaliza una URL de asset de storage al origen de api-core configurado.
 * El puerto 6000 (X11) lo BLOQUEA Chrome (ERR_UNSAFE_PORT) para <img> directos;
 * reescribimos a API_CORE_URL (dev = proxy /api/core same-origin). Idempotente.
 */
export function resolveAssetUrl(url: string | null | undefined): string {
  if (!url) return '';
  const marker = '/v1/storage/';
  const idx = url.indexOf(marker);
  if (idx === -1) return url;
  return `${API_CORE_URL}${url.slice(idx)}`;
}
